import React, { useState, useEffect, useRef } from "react";

const MobileCarouselBanner = ({slidersMain}) => {
    
    const [currentSlide, setCurrentSlide] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchMoveX, setTouchMoveX] = useState(0);
    const [isSwiping, setIsSwiping] = useState(false);
    const swiperRef = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isSwiping) {
                setCurrentSlide((prevSlide) => (prevSlide + 1) % slidersMain.length);
            }
        }, 6000); // Auto change slide every 6 seconds

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, [slidersMain.length, isSwiping]);

    const handleSlideChange = (index) => {
        setCurrentSlide(index);
    };

    const getTransformStyle = (index) => {
        const screenWidth = window.innerWidth; // Get current screen width
        const offset = index * screenWidth; // Adjust offset based on screen width
        const moveOffset = isSwiping ? touchMoveX - touchStartX : 0; // Adjust based on swipe
        return `translate3d(-${offset + moveOffset}px, 0px, 0px)`;
    };

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX); // Record the touch start position
        setTouchMoveX(e.touches[0].clientX); // Initialize move position
        setIsSwiping(true); // Indicate that the user is swiping
    };

    const handleTouchMove = (e) => {
        setTouchMoveX(e.touches[0].clientX); // Continuously update move position
    };

    const handleTouchEnd = () => {
        const swipeDistance = touchStartX - touchMoveX;
        const threshold = 50; // Minimum distance to consider it a valid swipe

        if (swipeDistance > threshold) {
            // Swiped left (next slide)
            setCurrentSlide((prevSlide) => (prevSlide + 1) % slidersMain.length);
        } else if (swipeDistance < -threshold) {
            // Swiped right (previous slide)
            setCurrentSlide((prevSlide) => (prevSlide - 1 + slidersMain.length) % slidersMain.length);
        }

        setIsSwiping(false); // Reset swiping state
    };

    return (
        <div className="home-banner">
            <div
                className="swiper-container"
                ref={swiperRef}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <div
                    className="swiper-wrapper"
                    style={{
                        transition: isSwiping ? 'none' : 'transform 0.3s ease', // Disable transition during swipe
                        transform: getTransformStyle(currentSlide), // Apply dynamic transform style
                    }}
                >
                    {slidersMain.map((slider, index) => (
                        <div key={slider.id} className="swiper-slide" data-swiper-slide-index={index}>
                            <img src={`${process.env.REACT_APP_API_URL}/storage/${slider.thubmnail}`} alt={slider.alt_text || 'Slider Image'} />
                        </div>
                    ))}
                </div>
                <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets">
                    {slidersMain.map((_, index) => (
                        <span
                            key={index}
                            className={`swiper-pagination-bullet ${currentSlide === index ? 'swiper-pagination-bullet-active' : ''}`}
                            tabIndex={0}
                            role="button"
                            aria-label={`Go to slide ${index + 1}`}
                            onClick={() => handleSlideChange(index)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MobileCarouselBanner;
